const defaultQuizzPayload = {
    quizzId: 0,
    userId: 0,
    radiosResponses: [],
    checkboxResponses: [],
    textResponses: []
}

const quizAldreadyReplied = ({ quizItem, userId }) => {
    const hasReplied = quizItem?.patientResponses?.find((item) => item?.id === userId)
    return hasReplied?.id > 0 ?? false
}

export { defaultQuizzPayload, quizAldreadyReplied }
